import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

import { Modal } from 'react-bootstrap';
import Select from 'react-select'
import DatePicker from "react-datepicker"

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api';
import { checkPermission, formatDate, formatMoney, formatMoneyInput } from 'helpers/helpers';

import Cheque from '../../../components/Cheque';
import { toast } from 'react-toastify';
import CustomTooltip from 'pages/parts/CustomTooltip';
import DeleteModal from 'pages/parts/DeleteModal';
import useDidMountEffect from 'pages/parts/useDidMountEffect';
// import MaskedInput from 'react-text-mask';

function Cashbox() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()
	const location = useLocation()
	const dispatch = useDispatch()

	const printChequeRef = useRef(null);
	const refs = useRef([]);
	const inputRefs = useRef([]);
	const rollSelectRefs = useRef([]);
	const sizeRefs = useRef([]);

	const handlePrint = useReactToPrint({
		content: () => printChequeRef.current,
	});

	const reduxAccount = useSelector(state => state.account)
	const reduxCashbox = useSelector(state => state.cashbox)
	const reduxTransferData = useSelector(state => state.transferData)

	const [activeTab, setActiveTab] = useState(1);
	const [activeRowIndex, setActiveRowIndex] = useState(0);

	const initData = {
		'cashier_name': reduxAccount.name,
		'cashier_phone': reduxAccount.phone,
		'paid': '',
		'selectedPaymentType': 'cash',
		'status': 1,
		'selectedProduct': {},
		'total': {
			1: {},
			3: {},
			4: {},
			5: {},
		},
		'products': [],
		'payments': reduxCashbox.paymentTypes.map(p => ({ ...p })),
		'paymentsCopy': reduxCashbox.paymentTypes.map(p => ({ ...p })),
		'parent_id': location.state?.parent_id || null,
		'client_id': location.state?.client_id || null,
		'delivery_type_id': location.state?.delivery_type_id || null,
		'address': location.state?.address || null,
		'region_id': location.state?.region_id || null,
		// Tўлов режаси — pul qanday keladi. Sotuvchi chek yozayotganda belgilaydi,
		// keyin ro'yxatdan shu bo'yicha filtrlab topiladi.
		'payment_plan': null,
	};

	// 4 ta reja. FAQAT 'nasiya'da qarz/nasiya sanasi so'raladi.
	// cash / half / driver — sanasiz, "Saqlash" bilan darhol tugaydi (user qarori 2026-07-16).
	const PAYMENT_PLANS = [
		{ key: 'cash', i18n: 'plan_cash', icon: '💵' },
		{ key: 'half', i18n: 'plan_half', icon: '🧾' },
		{ key: 'nasiya', i18n: 'plan_nasiya', icon: '📅' },
		{ key: 'driver', i18n: 'plan_driver', icon: '🚚' },
	];
	const planNeedsDebtDate = (plan) => ['nasiya'].includes(plan);

	const [data, setData] = useState({ ...initData })

	// СКИДКА (5-kategoriya) — yagona qo'lda kiritiladigan to'lov maydoni.
	// Qolganlari: Насия avtomatik, Накд/Банк/P2P esa ₴ tugmasi orqali olinadi.
	const discountIndex = (data.payments || []).findIndex(p => Number(p.payment_type_category_id) === 5)
	const [modalDebtDate, setModalDebtDate] = useState({ 'show': false });
	const [modalQuantity, setModalQuantity] = useState({ 'show': false });
	const [modalSelectProduct, setModalSelectProduct] = useState({ 'show': false });
	const [modalDelete, setModalDelete] = useState({ 'show': false });
	const [modalUser, setModalUser] = useState({ 'show': false });
	const [modalSearchUser, setModalSearchUser] = useState({ 'show': false });
	const [modalConfirm, setModalConfirm] = useState({ 'show': false });
	const [products, setProducts] = useState({
		'rolls': [],
		'shapes': [],
		'products': [],
		'categories': [],
		'accessories': [],
	})
	const [chequeStatuses, setChequeStatuses] = useState([])
	const [clients, setClients] = useState([])
	const [regions, setRegions] = useState([])
	const [deliveryTypes, setDeliveryTypes] = useState([])
	const [clientTypes, setClientTypes] = useState([])
	const [currentCurrency, setCurrentCurrency] = useState(0)
	const [chequeSubmitting, setChequeSubmitting] = useState(false) // dublikat chek himoyasi

	// Qator qoldiqdan oshib ketganmi (tanlangan rulon partiyasiga nisbatan)
	function isOverStock(p) {
		if (!p) return false
		const pt = Number(p.product_type)
		if (p.is_prepared) return Number(p.quantity) > Number(p.actual_balance || 0)
		if (pt === 4) return Number(p.metr) > Number(p.actual_balance || 0)
		if (pt === 3 || pt === 5) return Number(p.roll_metr) > Number(p.actual_balance || 0)
		if (pt === 1) return Number(p.quantity) > Number(p.balance || 0)
		return false
	}

	async function createCheque(checkDebt = true) {
		if (chequeSubmitting) return // tez ikki bosishda ikkita chek yaratilmasin
		var dataCopy = { ...data }

		// T11: bo'sh qatorlar (mahsulot tanlanmagan) chekka YOZILMASIN; tanlangan qatorda miqdor > 0 bo'lsin.
		const filledRows = (data.products || []).filter(p => p.product_id)
		if (filledRows.length === 0) {
			return toast.error(t('add_products'));
		}
		const zeroQtyRow = filledRows.find(p => !(Number(p.quantity) > 0))
		if (zeroQtyRow) {
			return toast.error("Har bir mahsulot qatorida miqdor 0 dan katta bo'lishi kerak");
		}
		dataCopy.products = filledRows
		if (!data.client_id) {
			return toast.error(t('select_client'));
		}
		if (data.paid <= 0 && data.discount_amount <= 0 && data.debt_amount <= 0) {
			return toast.error(t('fill_payment_type_field'));
		}
		if ((data.status === 2 || data.status === 3) && !data.delivery_date) {
			return toast.error(t('delivery_date_required'));
		}
		// Tўлов режаси majburiy — sotuvchi "pul qanday keladi"ni belgilashi shart,
		// aks holda chekni keyin ro'yxatdan topib bo'lmaydi.
		if (!data.payment_plan) {
			return toast.error(t('payment_plan_required'));
		}
		// Hudud majburiy — FAQAT yangi chekda (eski chek tahririni bloklamaydi va
		// mijozning mavjud hududini jimgina qayta yozib yubormaydi). id bo'lsa = tahrirlash.
		if (!id && !data.region_id) {
			return toast.error(t('region_required'));
		}
		// Qarz qoladigan rejalarda (yarim / nasiya / shofyordan) muddat bo'lishi shart
		if (planNeedsDebtDate(data.payment_plan) && !data.debt_date) {
			return toast.error(t('debt_date_required'));
		}

		// Qarz sana modali FAQAT Насия rejasида (cash/half/driver — sanasiz saqlanadi).
		// (Насия tanlanganда sana yuqoridagi maydondan kiritiladi — u holda 145-qatorda tekshiriladi.)
		if (checkDebt && !id && !data.debt_date && planNeedsDebtDate(data.payment_plan)) {
			var payment = dataCopy.payments.find(item => item.payment_type_category_id === 3 && item.amount > 0)
			if (payment?.amount > 0) {
				setData({ ...data, debt_date: new Date() })
				setModalDebtDate({ show: true })
				return;
			}
		}

		dataCopy.shift_id = reduxAccount.shift?.id;

		// Ogohlantirish: biror qatorda tanlangan rulon partiyasi qoldig'i yetarli emas (manfiy).
		// Yetishmagani boshqa OCHILGAN rulondan ayiriladi yoki "Rulon qarzi" (kutilayotgan)ga o'tadi.
		const shortLines = (data.products || []).filter(p => p.show && isOverStock(p))
		if (shortLines.length > 0) {
			toast.info("Diqqat: ba'zi rulonlarda qoldiq yetarli emas — yetishmagani boshqa ochilgan rulondan yoki «Rulon qarzi»ga o'tadi.")
		}

		// location.state?.parent_id har doim saqlansin (data.parent_id yo'qolib qolgan bo'lsa ham)
		if (location.state?.parent_id) {
			dataCopy.parent_id = location.state.parent_id;
		}

		var response;
		setChequeSubmitting(true)
		try {
			if (id) {
				response = await PUT('/cheques', dataCopy, { loader: true })
			} else {
				dataCopy.currency = currentCurrency;
				response = await POST('/cheques', dataCopy, { loader: true })
			}

			if (httpOk(response)) {
				clearData()
				navigate(location.state?.parent_id ? '/cashbox' : -1)
			};
		} finally {
			setChequeSubmitting(false)
		}
	}

	function printCheque(a4 = false) {
		setData({ ...data, a4: a4 })

		setTimeout(() => {
			handlePrint()
		}, 200);
	}

	function clearData() {
		setData(structuredClone(initData))
		if (modalConfirm.show) setModalConfirm({ show: false })
		saveTransferData(initData)
	}

	function calculateTotalAmount(dataCopy) {
		var change = 0
		var paid = 0
		dataCopy.discount_amount = 0;
		dataCopy.debt_amount = 0;
		dataCopy.total_amount = 0;

		const totals = {
			1: { amount: 0, quantity: 0, },
			3: { amount: 0, metr: 0, roll_metr: 0, },
			4: { amount: 0, metr: 0, },
			5: { amount: 0, metr: 0, roll_metr: 0, kv_metr: 0, }
		};

		// dataCopy.corrugation_total_amount = 0;
		// dataCopy.accessory_total_amount = 0;
		// dataCopy.product_total_amount = 0;
		// dataCopy.tunicophone_total_amount = 0;

		for (let i = 0; i < dataCopy?.payments?.length; i++) {
			if (dataCopy.payments[i]['payment_type_category_id'] === 3) {
				dataCopy.debt_amount += Number(dataCopy.payments[i]['amount'])
			}
			if (dataCopy.payments[i]['payment_type_category_id'] !== 5 && dataCopy.payments[i]['payment_type_category_id'] !== 3) {
				paid += Number(dataCopy.payments[i]['amount'])
			} else if (dataCopy.payments[i]['payment_type_category_id'] === 5) {
				dataCopy.discount_amount += Number(dataCopy.payments[i]['amount']);
			}
		}

		for (let i = 0; i < dataCopy?.products?.length; i++) {
			// if (dataCopy?.products[i].product_type === 3) {
			// 	dataCopy.products[i]['accessory_sale_price'] = Math.round((Number(dataCopy.products[i]['sale_price'] ?? 0) + Number(dataCopy.products[i]['markup'] ?? 0)))
			// 	dataCopy.products[i]['accessory_sale_price'] = Math.round(Number(dataCopy.products[i]['accessory_sale_price']) * Number(dataCopy.products[i]['roll_metr'] ?? 0))
			// }

			if (dataCopy?.products[i].product_type === 1) {
				dataCopy.products[i]['total_price'] = Math.round(dataCopy.products[i]['sale_price'] * dataCopy.products[i]['quantity']);
			} else if (dataCopy?.products[i].is_prepared) {
				dataCopy.products[i]['total_price'] = Math.round(Number(dataCopy.products[i]['sale_price']) * Number(dataCopy.products[i]['quantity']));
			} else if (dataCopy?.products[i].product_type === 3 || dataCopy?.products[i].product_type === 5) {
				dataCopy.products[i]['total_price'] = Math.round(Number(dataCopy.products[i]['accessory_total_price']));
			} else {
				dataCopy.products[i]['total_price'] = Math.round(Number(dataCopy.products[i]['sale_price']) * Number(dataCopy.products[i]['metr']));
			}


			dataCopy.total_amount = dataCopy.total_amount + Number(dataCopy.products[i]['total_price']);

			const product = dataCopy?.products[i];
			const type = product.product_type;
			if (totals[type]) {
				totals[type].amount += Number(product.total_price || 0);
				totals[type].metr += Number(product.metr || 0);
				totals[type].roll_metr += Number(product.roll_metr || 0);
				totals[type].kv_metr += Number(product.kv_metr || 0);
				totals[type].quantity += Number(product.quantity || 0);
			}

			// if (dataCopy?.products[i].product_type === 1) {
			// 	dataCopy.product_total_amount = dataCopy.product_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
			// if (dataCopy?.products[i].product_type === 3) {
			// 	dataCopy.accessory_total_amount = dataCopy.accessory_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
			// if (dataCopy?.products[i].product_type === 4) {
			// 	dataCopy.corrugation_total_amount = dataCopy.corrugation_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
			// if (dataCopy?.products[i].product_type === 5) {
			// 	dataCopy.tunicophone_total_amount = dataCopy.tunicophone_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
		}

		dataCopy.total = totals;

		if (dataCopy.delivery_price) {
			dataCopy.total_amount += Number(dataCopy.delivery_price);
		}
		if (dataCopy?.discount_amount) {
			dataCopy.total_amount -= Number(dataCopy.discount_amount);
		}

		// ── НАСИЯ (qarz) AVTOMATIK ────────────────────────────────────────────────
		// Pul endi chek YOZILGANDA emas, OLINGANDA kiritiladi (cheklar ro'yxatidagi ₴ tugmasi).
		// Shuning uchun kassir "Насия" ni qo'lda yozmaydi — u shu yerda o'zi hisoblanadi:
		//     qarz = jami (chegirmadan keyin) − allaqachon to'langan
		// Eski chekni tahrirlaganda `paid` haqiqiy qiymat bo'ladi -> to'langan pul yo'qolmaydi.
		const autoDebt = Math.max(Number(dataCopy.total_amount) - Number(paid), 0)
		dataCopy.payments = (dataCopy.payments || []).map(p =>
			Number(p.payment_type_category_id) === 3 ? { ...p, amount: autoDebt } : p
		)
		dataCopy.debt_amount = autoDebt

		if (paid > dataCopy.total_amount) {
			var temporaryChange = Number(paid) - Number(dataCopy.total_amount)
			if (temporaryChange > 0) {
				change = temporaryChange
			} else {
				change = 0
			}
		}

		dataCopy.entity_debtor_amount = 0;
		if (dataCopy.entity_debtor_id) {
			if (paid >= dataCopy.total_amount) {
				dataCopy.entity_debtor_id = null
				dataCopy.entity_debtor_name = null
				dataCopy.entity_debtor_type = null
				dataCopy.entity_debtor_amount = 0
			} else {
				dataCopy.entity_debtor_amount =
					dataCopy.total_amount -
					paid -
					dataCopy.temporaryDiscount
			}
		}

		var totalPayments = (
			Number(paid) +
			Number(dataCopy.temporaryDiscount)
		)

		dataCopy['discount_percentage'] = (Number(dataCopy['discount']) / Number(dataCopy['total_amount']) * 100)

		if (totalPayments <= Number(dataCopy.total_amount)) {
			dataCopy.shortage =
				Number(dataCopy.total_amount) -
				Number(totalPayments) -
				Number(dataCopy.entity_debtor_amount) -
				Number(dataCopy.organization_amount)
		}

		if (Number(paid) > Number(dataCopy.total_amount)) {
			dataCopy.shortage = 0
		}

		const elementBalanceMap = {};

		if (id) {
			dataCopy.products.forEach(product => {
				if (product.element_id && !product.is_prepared) {
					const key = `${product.element_id}-${product.balance_id}`;

					if (elementBalanceMap[key] === undefined) {
						elementBalanceMap[key] = Number(product.balance) || 0;
					}

					if (product.id) {
						const amount = product.product_type === 4
							? Number(product.metr || 0)
							: Number(product.roll_metr || 0);
						elementBalanceMap[key] += amount;
					}
				}
			});
		}

		dataCopy.products = dataCopy.products.map(product => {
			if (product.is_prepared) {
				return {
					...product,
					actual_balance: Number(product.balance) || 0,
				};
			}

			if (product.element_id) {
				if (elementBalanceMap[`${product.element_id}-${product.balance_id}`] === undefined) {
					elementBalanceMap[`${product.element_id}-${product.balance_id}`] = Number(product.balance) || 0;
				}

				const before = elementBalanceMap[`${product.element_id}-${product.balance_id}`];

				if (product.product_type === 4) {
					elementBalanceMap[`${product.element_id}-${product.balance_id}`] = before - Number(product.metr || 0);
				}
				if (product.product_type === 3 || product.product_type === 5) {
					elementBalanceMap[`${product.element_id}-${product.balance_id}`] = before - Number(product.roll_metr);
				}

				return {
					...product,
					actual_balance: before,
				};
			}

			return {
				...product,
				actual_balance: product.balance,
			};
		});

		const balanceMap = dataCopy.products.reduce((map, product) => {
			if (product.product_type === 4) {
				map[`${product.element_id}-${product.balance_id}`] = product.actual_balance - product.metr;
			}
			if (product.product_type === 3 || product.product_type === 5) {
				map[`${product.element_id}-${product.balance_id}`] = product.actual_balance - product.roll_metr;
			}
			return map;
		}, {});

		var productsCopy = { ...products }
		if (productsCopy.categories.length > 0) {
			productsCopy.categories = productsCopy.categories.map(category => {
				const updatedCategoryProducts = category.products.map(product => {
					const key = `${product.product_id}-${product.balance_id}`;
					const actual_balance = balanceMap[key];
					return {
						...product,
						actual_balance: actual_balance !== undefined ? actual_balance : product.balance,
					};
				});

				return {
					...category,
					products: updatedCategoryProducts,
				};
			});

			setProducts(productsCopy)
		}

		setData({
			...dataCopy,
			'change': change,
			'paid': paid,
			'entity_debtor_amount': dataCopy.entity_debtor_amount,
			'shortage': dataCopy.shortage,
		})

		saveTransferData({
			...dataCopy,
			'change': change,
			'paid': paid,
			'entity_debtor_amount': dataCopy.entity_debtor_amount,
			'shortage': dataCopy.shortage,
		})
	}

	function saveTransferData(data) {
		if (!id) {
			dispatch({
				type: 'SET_CHEQUE_DATA',
				payload: { ...data }
			})
		}
	}

	function exactAmount(index) {
		var dataCopy = { ...data }
		dataCopy.total_amount += dataCopy.discount_amount;
		var paid = 0
		for (let i = 0; i < dataCopy.payments.length; i++) {
			if (index !== i) {
				paid += Number(dataCopy.payments[i]['amount']);
			}
		}

		if (Number(dataCopy.total_amount) > Number(paid)) {
			dataCopy.payments[index]['amount'] = Math.round(Number(dataCopy.total_amount) - Number(paid))
			if (dataCopy.payments[index]['is_usd']) {
				// currentCurrency=0 (kurs hali yuklanmagan) da Infinity bo'lmasin
				dataCopy.payments[index]['amount_usd'] = currentCurrency > 0
					? Math.ceil((Number(dataCopy.total_amount) - Number(paid)) / currentCurrency)
					: 0
			}
		}
		calculateTotalAmount(dataCopy)
	}

	async function handleChange(e) {
		var dataCopy = { ...data }
		dataCopy[e.target.name] = e.target.value.replace(/[^0-9.]/g, '');

		if (e.target.name === "debt_days") {
			const result = new Date();
			result.setDate(result.getDate() + parseInt(dataCopy.debt_days ? dataCopy.debt_days : 0, 10));
			dataCopy.debt_date = result;
		}
		setData(dataCopy)
	}

	function handleChangePayment(index, e) {
		var dataCopy = { ...data }
		if (dataCopy.payments[index]['is_usd']) {
			dataCopy.payments[index]['amount_usd'] = sanitizeDecimal(e.target.value);
			dataCopy.payments[index]['amount'] = dataCopy.payments[index]['amount_usd'] * currentCurrency;
		} else {
			dataCopy.payments[index]['amount'] = sanitizeDecimal(e.target.value);
		}
		calculateTotalAmount(dataCopy)
	}

	async function toggleModalDelete(bool, item, index) {
		if (bool) {
			if (item.id) {
				setModalDelete({ ...modalDelete, product: item, show: true, note: '' })
			} else {
				deleteItem(index)
			}
		} else {
			setModalDelete({ show: false })
		}
	}

	async function deleteItem(payloadIndex) {
		var dataCopy = { ...data };
		var productsCopy = [...dataCopy.products];
		var index;
		if (payloadIndex >= 0) {
			index = payloadIndex;
		} else {
			index = dataCopy.products.findIndex(item => item.id === modalDelete.product.id);

			if (modalDelete.product.id) {
				const response = await DELETE(`/cheques-delete-product`, { 'cheque_id': id, 'id': modalDelete.product.id, note: modalDelete.note }, { loader: true })
				if (!httpOk(response)) {
					return;
				}
			}

		}

		productsCopy.splice(index, 1);

		dataCopy.products = productsCopy;

		setModalDelete({ show: false })
		if (payloadIndex >= 0) {
			calculateTotalAmount(dataCopy);
		} else {
			getProducts(dataCopy)
		}
	}

	function addProductType2(e) {
		e.preventDefault();

		var item = { ...modalQuantity }
		var dataCopy = { ...data }

		item.status = 0;
		dataCopy.products.push(item)

		setModalQuantity({ show: false })
		calculateTotalAmount(dataCopy)
	}

	function handleChangeProductSelect(index, key, value) {
		var dataCopy = structuredClone(data)
		var product = dataCopy.products[index];

		// T4: yangi mahsulot tanlanganda qo'lda kiritilgan narx bayrog'i tozalanadi (yangi mahsulot — yangi narx)
		product['is_price_manual'] = false;

		// if (activeTab !== 3 && value.balance_id && key !== 'element_id' && !modalSelectProduct.is_prepared) {
		// 	setModalSelectProduct({
		// 		show: true,
		// 		index: index,
		// 		key: 'product_id',
		// 		is_prepared: true,
		// 		product_id: value.product_id
		// 	})
		// 	return;
		// }

		if (!value.is_opened && modalSelectProduct.show && modalSelectProduct.key === 'element_id') {
			toast.error(t('roll_not_open'));
			return;
		}

		if (product.quantity) {
			product.quantity = '';
			product.element_quantity = "";
			product.metr = "";
			product.roll_metr = "";
			// product.sale_price = 0;
		}

		if (key === 'element_id') {
			product['element_balance_id'] = value?.balance_id;
			product['element_name'] = value.name;
			product['element_id'] = value.product_id;
			product['roll_quantity'] = value.quantity;
			product['balance'] = value.balance;
			product['created_at'] = value.created_at;
			product['sale_price'] = value.sale_price;
			product['price'] = value.price;
			product['wms_id'] = value.wms_id;
			product['balance_id'] = value.balance_id;
			product['element_category_name'] = value.category_name;
			product['is_new'] = value.balance === value.quantity;
		} else if (activeTab === 3) {
			dataCopy.products[index] = {
				...dataCopy.products[index],
				...value,
				product_name: value.name,
				quantity: '',
			};
		} else if (activeTab === 1) {
			product['product_id'] = value.product_id;
			product['product_name'] = value.name;
			product['percentage'] = value.percentage;
			product['is_prepared'] = false;
			// product['balance'] = "";
			// product['balance_id'] = "";
		} else {
			product['product_id'] = value.product_id;
			product['product_name'] = value.name;
			product['width'] = value.width;
			product['length'] = value.length;
			product['markup'] = value.markup;
			product['is_prepared'] = false;
			// product['balance'] = "";
			// product['balance_id'] = "";
		}

		if (activeTab !== 3 && value.balance_id && key !== 'element_id') {
			// product = structuredClone(value);

			product['wms_id'] = value.wms_id;
			product['balance'] = value.balance;
			product['balance_id'] = value.balance_id;
			product['element_balance_id'] = value.balance_id;
			product['is_prepared'] = true;
			product['sale_price'] = value.sale_price;
			// product['accessory_sale_price'] = value.sale_price;
			product['accessory_sale_price_metr'] = value.sale_price;
			product['element_id'] = value.element_id;
			product['element_name'] = value.element_name;
			product['created_at'] = value.created_at;

			setTimeout(() => {
				if (inputRefs.current[index] && inputRefs.current[index]) {
					inputRefs.current[index].focus();
				}
			}, 10);
		}

		if (modalSelectProduct.show) {
			setModalSelectProduct({ show: false })
		}
		calculateTotalAmount(dataCopy)

		// Rulon (partiya) tanlangach fokusni "Хажми" (element_quantity) input'iga ko'chiramiz —
		// foydalanuvchi darrov o'lchamni yozsin, partiya select'iga qaytib qolmasin.
		if (key === 'element_id') {
			setTimeout(() => {
				if (sizeRefs.current[index]) sizeRefs.current[index].focus();
			}, 50);
		}
	}

	function handleChangeCategoriesSelect(index, option) {
		if (option.value === 'preparation') {
			var dataCopy = { ...data }
			var product = dataCopy.products[index];

			product['balance'] = product.product_balance;

			return;
		}
		setModalSelectProduct({ show: true, index: index, key: 'element_id', children: option.products })
	}

	// Rulon-select — klaviatura: Enter bosilganda partiya (rulonlar) oynasini ochadi.
	// onKeyDownCapture (o'rash div'ida) react-select'dan OLDIN (capture fazasi) ishlaydi —
	// shuning uchun Enter'ni ishonchli ushlaydi. Fokusdagi kategoriya react-select ichki
	// holatidan (ref) olinadi; topilmasa — barcha rulonlar ko'rsatiladi (fallback).
	function handleRollCategoryKeyDown(e, index) {
		if (e.key !== 'Enter') return;
		e.preventDefault();
		e.stopPropagation();
		const focused = rollSelectRefs.current[index]?.state?.focusedOption;
		const children = (focused && Array.isArray(focused.products)) ? focused.products : products.rolls;
		setModalSelectProduct({ show: true, index: index, key: 'element_id', children: children });
	}

	// T12: bir nechta nuqtali son ("1.2.3" -> NaN) kiritishga yo'l qo'ymaydi — faqat birinchi nuqta qoladi
	function sanitizeDecimal(raw) {
		let v = String(raw ?? '').replace(/[^\d.]/g, '');
		const dot = v.indexOf('.');
		if (dot !== -1) v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, '');
		return v;
	}

	function handleChangeProduct(index, e) {
		var dataCopy = structuredClone(data)
		var product = dataCopy.products[index];
		var value = sanitizeDecimal(e.target.value);

		if (e.target.name === 'accessory_sale_price_metr') {
			product[e.target.name] = e.target.value.replace(/\D/g, '');
		} else {
			product[e.target.name] = value;
		}

		// T4: kassir narxni QO'LDA kiritsa, uni belgilaymiz — miqdor o'zgarganda avto-hisob uni o'chirmasin
		if (e.target.name === 'accessory_sale_price') {
			product['is_price_manual'] = true;
		}

		// Подсчет метра
		if (product['is_prepared']) {

			if (product['product_type'] === 4) {
				product['total_price'] = Number(product['quantity']) * Number(product['sale_price']);
				product['metr'] = Number(product['quantity']);
			} else if (product['product_type'] === 3 || product['product_type'] === 5) {
				product['accessory_total_price'] = Number(product['quantity']) * Number(product['accessory_sale_price_metr']);
				product['sale_price'] = product['accessory_sale_price_metr'];
				product['total_price'] = product['accessory_total_price'];
			}
		} else {
			if (e.target.name === 'quantity' || e.target.name === 'element_quantity') {
				product['metr'] = (product['quantity'] ?? 0) * (product['element_quantity'] ?? 0);

				// Добавлять к метру процент
				if (product['percentage']) {
					product['metr'] =
						((product['element_quantity'] * product['quantity'])) +
						(product['element_quantity'] * product['quantity']) *
						(product['percentage'] / 100);
				}
			}
			if (product['product_type'] === 3 || product['product_type'] === 5) {
				// length=0/undefined da nolga bo'linish (Infinity/NaN narx) bo'lmasin
				const prodLength = Number(product['length'])
				product['roll_metr'] = prodLength > 0 ? product['metr'] / prodLength * Number(product['width'] ?? 0) : 0;
				if (product['product_type'] === 5) {
					product['kv_metr'] = (product['roll_metr'] ?? 0) * (product['length'] ?? 0);
				}
				if (e.target.name !== 'accessory_sale_price' && !product['is_price_manual']) {
					product['accessory_sale_price'] = Math.round((Number(product['price'] ?? 0) + Number(product['markup'] ?? 0)))
				}
				if (e.target.name !== 'accessory_total_price') {
					product['accessory_total_price'] = Math.round(product['accessory_sale_price'] * (product['product_type'] === 5 ? product['kv_metr'] : Number(product['roll_metr'])))
					// product['accessory_total_price'] = Math.round(product['accessory_sale_price'] * Number(product['roll_metr']))
				}
				if (e.target.name === 'accessory_sale_price_metr') {
					product['accessory_total_price'] = Math.round(product['accessory_sale_price_metr'] * Number(product['metr']))
				}
				if (e.target.name !== 'accessory_sale_price_metr') {
					const metrNum = Number(product['metr'])
					product['accessory_sale_price_metr'] = metrNum > 0 ? Math.round(Number(product['accessory_total_price']) / metrNum) : 0
				}
			}
		}
		// BACKORDER: qoldiqdan oshiq miqdor kiritishga RUXSAT beriladi (buyurtma).
		// Ilgari bu yerda return bilan bloklanardi (qoldiqdan oshirib bo'lmasdi). Endi bloklamaymiz —
		// ombor yetmasa, yetishmagan qism backendda "kutilayotgan buyurtma" (pending_orders) bo'ladi.
		// Qoldiq (actual_balance) manfiyga tushsa qizil bo'lib ko'rinadi — bu ogohlantirish.

		dataCopy.products[index] = product;
		calculateTotalAmount(dataCopy)
	}

	function onKeyPress(e, index) {
		var products = getDataProducts().filter(item => item.show);
		var currentProduct = data.products[index];

		var filteredIndex = products.findIndex(p => {
			if (currentProduct.id) {
				return p.id === currentProduct.id;
			} else {
				return p.unique_id === currentProduct.unique_id;
			}
		});

		if ((e.key === 'Tab' || e.key === 'Enter') && filteredIndex === products.length - 1) {
			addToList(1, (activeTab === 1 || activeTab === 2) ? data.products[index] : {});
		}
	}

	function addToList(length = 1, item = {}) {
		var dataCopy = structuredClone(data)
		var productType = 1;
		if (activeTab === 1) {
			productType = 4;
		} else if (activeTab === 2) {
			productType = 3;
		} else if (activeTab === 4) {
			productType = 5;
		}
		for (let i = 0; i < length; i++) {
			dataCopy.products.push({
				...item,
				'quantity': '',
				'element_width': '',
				'element_quantity': '',
				'total_price': '',
				'metr': '',
				'id': '',
				'product_type': productType,
				'unique_id': Date.now(),
			})
		}

		// setIsDirty(true)
		calculateTotalAmount(dataCopy)

		setTimeout(() => {
			refs.current[dataCopy.products.length - 1]?.focus()
		}, 150);
	}

	// «Tayyor ombordan» — yangi qator qo'shib, o'sha qator uchun tayyor mahsulotlar modalini ochamiz.
	// (Eski chalkash ⋮ 3-nuqta o'rniga aniq tugma.)
	function addReadyRow() {
		const idx = data.products.length
		addToList()
		setTimeout(() => setModalSelectProduct({ show: true, index: idx, key: 'product_id' }), 250)
	}

	async function getClientTypes() {
		const response = await GET('/helper/clients-types', {}, { loader: true })
		if (httpOk(response)) setClientTypes(response.data)
	}

	async function toggleUserModal(bool) {
		if (!clientTypes.length) await getClientTypes()
		if (bool) {
			setModalUser({ ...modalUser, show: true, name: '', phine: '', client_type_id: '', birthday: '', gender: 1, note: '' })
		} else {
			setModalUser({ show: false })
		}
	}

	function selectClient(item) {
		setData({
			...data,
			client_id: item.id,
			client_name: item.name,
			client_phone: item.phone,
			client_balance: item.balance,
			region_id: item.region_id ?? null,
		})
	}

	async function toggleSearchUserModal(bool, item = {}) {
		if (bool) {
			setModalSearchUser({ ...modalUser, show: true, })
		} else {
			setData({
				...data,
				client_id: item.id,
				client_name: item.name,
				client_phone: item.phone,
				client_balance: item.balance,
				region_id: item.region_id ?? null,
			});
			setModalSearchUser({ show: false })
		}
	}

	async function createUser(e) {
		e.preventDefault();

		var response;
		if (modalUser.id) {
			response = await PUT('/clients', modalUser, { loader: true })
		} else {
			response = await POST('/clients', modalUser, { loader: true })
		}

		if (httpOk(response)) {
			// Yangi qo'shilgan mijozni zakaz oynasida DARROV tanlaymiz — qayta qidirib topish shart emas.
			// (faqat yangi yaratishda; tahrirlashda joriy tanlov o'zgarmasin)
			if (!modalUser.id && response.data?.id) {
				const newClient = { ...response.data, balance: response.data.balance ?? 0 }
				setClients(prev => [newClient, ...prev])
				selectClient(newClient)
			}
			getClients()
			setModalUser({ show: false })
		}
	}

	function handleInputUserChange(e) {
		var modalUserCopy = { ...modalUser }
		modalUserCopy[e.target.name] = e.target.value
		setModalUser(modalUserCopy)
	}

	function handleInputChange(e) {
		var dataCopy = { ...data }
		dataCopy[e.target.name] = e.target.value;
		setData(dataCopy)
	}

	async function getProducts(dataCopy = false) {
		var response = await GET('/helper/products')
		if (httpOk(response)) { // avval tekshiruv — xato javobda crash bo'lmasin
			for (let i = 0; i < (response.data.allPreparedProducts ?? []).length; i++) {
				var index = -1;
				const preparedProduct = response.data.allPreparedProducts[i]
				if (preparedProduct.product_type === 3) {
					index = response.data.accessories.findIndex(item => item.product_id === preparedProduct.product_id)
					response.data.accessories.splice(index, 0, response.data.allPreparedProducts[i]);
				} if (preparedProduct.product_type === 4) {
					index = response.data.shapes.findIndex(item => item.product_id === preparedProduct.product_id)
					response.data.shapes.splice(index, 0, response.data.allPreparedProducts[i]);
				} if (preparedProduct.product_type === 5) {
					index = response.data.tunicophones.findIndex(item => item.product_id === preparedProduct.product_id)
					response.data.tunicophones.splice(index, 0, response.data.allPreparedProducts[i]);
				}
			}
			setProducts(prev => ({ ...prev, ...response.data }))
			if (dataCopy) {
				setTimeout(() => {
					calculateTotalAmount(dataCopy);
				}, 600);
			}
		};
	}

	async function getChequeStatuses() {
		const response = await GET('/helper/cheques-statuses')
		if (httpOk(response)) setChequeStatuses(response.data)
	}

	async function getClients() {
		const response = await GET('/helper/clients')
		if (httpOk(response)) setClients(response.data)
	}

	async function getRegions() {
		const response = await GET('/regions')
		if (httpOk(response)) setRegions(response.data)
	}

	// Yassi hudud ro'yxatidan react-select variantlari (yo'l bilan: Chem — Andijon › Andijon shahri)
	function regionOptions() {
		const byId = {}
		regions.forEach(r => { byId[r.id] = r })
		return regions.map(r => {
			const path = []
			let cur = r
			while (cur && cur.parent_id && byId[cur.parent_id]) { cur = byId[cur.parent_id]; path.unshift(cur.name) }
			return { value: r.id, name: r.name, path: path.join(' › '), type: r.type }
		})
	}

	async function getDeliveryTypes() {
		const response = await GET('/helper/delivery-types')
		if (httpOk(response)) setDeliveryTypes(response.data)
	}

	async function getCurrentCurrency() {
		const response = await GET('/current-currency')
		if (httpOk(response)) setCurrentCurrency(response.data)
	}


	async function getData() {
		const response = await GET(`/cheques/${id}`)
		if (httpOk(response)) {
			for (let i = 0; i < response.data.products.length; i++) {
				var product = response.data.products[i];
				if (product['product_type'] === 4 || product['product_type'] === 3 || product['product_type'] === 5) {
					product['metr'] = (product['quantity'] ?? 0) * (product['element_quantity'] ?? 0);
					if (product['percentage']) {
						product['metr'] =
							((product['element_quantity'] * product['quantity'])) +
							(product['element_quantity'] * product['quantity']) *
							(product['percentage'] / 100);
					}
				}
				if (product['is_prepared']) {
					product['accessory_total_price'] = Math.round((Number(product['accessory_sale_price']) * Number(product['quantity'])))
					product['accessory_sale_price_metr'] = Math.round(product['accessory_sale_price'])

					if (product['product_type'] === 4) {
						product['metr'] = product['quantity'];
					}

				} else if (product['product_type'] === 3) {
					product['accessory_sale_price_metr'] = Math.round(product['sale_price'])
					product['accessory_total_price'] =
						Math.round((Number(product['sale_price']) * product['metr']))
				} else if (product['product_type'] === 5) {
					product['kv_metr'] = (product['roll_metr'] ?? 0) * (product['length'] ?? 0);
					product['accessory_total_price'] =
						Math.round((Number(product['sale_price']) * product['kv_metr']))
				}
				if (product['element_id']) {
					product['element_balance_id'] = product['balance_id']
				}
			}
			response.data.paymentsCopy = structuredClone(data.payments)
			response.data.payments = structuredClone(data.payments).map(type => {
				// ₴ qarz-inkassa qatorlarini (is_debt_payment=true) tahrir shabloniga OLMAYMIZ —
				// aks holda ular naqd/bank shabloniga ko'chib, saqlashda dublikat to'lov + fantom
				// mijoz krediti + smena naqdi 2× bo'ladi (KRITIK-1). Ular bazada tegilmay qoladi.
				const payment = response.data.payments.find(p => p.payment_type_id === type.payment_type_id
					&& !(p.is_debt_payment === true || p.is_debt_payment === 1 || p.is_debt_payment === '1' || p.is_debt_payment === 't'));
				if (payment) {
					return {
						...type,
						amount: payment.amount,
						amount_usd: type.is_usd && Number(response.data.currency ?? currentCurrency) > 0
							? Math.ceil(payment.amount / Number(response.data.currency ?? currentCurrency))
							: 0,
					};
				} else {
					return {
						...type,
						amount: 0,
						amount_usd: 0,
					};
				}
			})

			if (response.data.currency) setCurrentCurrency(response.data.currency)
			calculateTotalAmount(response.data)
		}
	}

	useEffect(() => {
		getProducts()
		getClients()
		getRegions()
		getChequeStatuses()
		getDeliveryTypes()

		if (id) {
			getData()
		} else {
			if (location.state?.parent_id) {
				// Qo'shimcha zakaz — eski mahsulotlarni olmaydi, faqat mijoz va parent_id
				getCurrentCurrency()
			} else if (reduxTransferData?.chequeData?.products?.length > 0) {
				setData(structuredClone(reduxTransferData.chequeData))
				getCurrentCurrency()
			} else {
				getCurrentCurrency()
			}
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const products = getProductsList(); // берём текущий список
		if (modalSelectProduct.show) {
			const handleKeyDown = (e) => {
				switch (e.key) {
					case "ArrowUp": // вверх
						e.preventDefault();
						setActiveRowIndex(prev => prev > 0 ? prev - 1 : products.length - 1);
						break;
					case "ArrowDown": // вниз
						e.preventDefault();
						setActiveRowIndex(prev => prev < products.length - 1 ? prev + 1 : 0);
						break;
					case "Enter": // Enter
						e.preventDefault();
						const item = products[activeRowIndex];
						if (!item) break;   // T7: aktiv qator yo'q bo'lsa crash (products[undefined]) bo'lmasin
						handleChangeProductSelect(
							modalSelectProduct.index,
							modalSelectProduct.key,
							item   // T8: Enter ham sichqoncha kabi BUTUN obyektni uzatsin (aks holda qator nomsiz/narxsiz qoladi)
						);
						break;
					default:
						break;
				}
			};

			document.addEventListener('keydown', handleKeyDown);
			return () => {
				document.removeEventListener('keydown', handleKeyDown);
			};
		} else {
			if (activeRowIndex >= 0) {
				setActiveRowIndex(0)   // T7: undefined qoldirmaymiz — keyingi Enter da products[undefined] crash bermasin
			}
		}
	}, [modalSelectProduct.show, activeRowIndex, modalSelectProduct, getProductsList]); // eslint-disable-line react-hooks/exhaustive-deps


	useDidMountEffect(() => {
		calculateTotalAmount(data)
	}, [data.delivery_price]); // eslint-disable-line react-hooks/exhaustive-deps

	function getDataProducts() {
		if (!data.products.length) {
			return [];
		}
		var products = [...data.products]
		for (let i = 0; i < products.length; i++) {
			var item = products[i];
			item.show = false;
			if (activeTab === 1 && item.product_type === 4) {
				item.show = true;
			}
			if (activeTab === 2 && item.product_type === 3) {
				item.show = true;
			}
			if (activeTab === 3 && item.product_type === 1) {
				item.show = true;
			}
			if (activeTab === 4 && item.product_type === 5) {
				item.show = true;
			}
		}

		return products;
	}

	function getProductsList() {
		var arr = []
		if (!modalSelectProduct.show) return arr;

		if (activeTab === 1) {
			arr = products.shapes;
		}
		if (activeTab === 2) {
			arr = products.accessories;
		}
		if (activeTab === 3) {
			arr = products.products;
		}
		if (activeTab === 4) {
			arr = products.tunicophones;
		}
		if (modalSelectProduct.is_prepared) {
			arr = products.allPreparedProducts;
		}

		if (activeTab === 1) {
			arr = arr.filter(item => item.product_type === 4 && item.is_prepared)
		}
		if (activeTab === 2) {
			arr = arr.filter(item => item.product_type === 3 && item.is_prepared)
		}
		if (activeTab === 3) {
			arr = arr.filter(item => item.product_type === 1 && item.is_prepared)
		}
		if (activeTab === 4) {
			arr = arr.filter(item => item.product_type === 5 && item.is_prepared)
		}

		if ((activeTab === 1 || activeTab === 2 || activeTab === 4) && modalSelectProduct.key === 'element_id') {
			arr = modalSelectProduct.children
		}

		if (modalSelectProduct.search) {
			arr = arr.filter(item =>
				item.name.toLowerCase().includes(modalSelectProduct.search.toLowerCase()) ||
				(item.element_name && item.element_name.toLowerCase().includes(modalSelectProduct.search.toLowerCase()))
			);
		}

		return arr;
	}


	function getClientsList() {
		var arr = [...clients]

		if (modalSearchUser.search) {
			arr = arr.filter(item =>
				item?.name?.toLowerCase()?.includes(modalSearchUser.search?.toLowerCase()) ||
				item?.phone?.toLowerCase()?.includes(modalSearchUser.search?.toLowerCase())
			);
		}

		return arr;
	}

	function isButtonDisabled(isSave = false) {
		if (!data.products.length) {
			return true;
		}

		// Qarz ham hisobga olinadi: pul endi chek yozilganda kiritilmaydi (₴ tugmasi orqali olinadi),
		// shuning uchun yangi chekda paid har doim 0 bo'ladi. Faqat paid/discount tekshirilsa,
		// chop etish tugmalari doim o'chiq qolardi.
		if (data.paid <= 0 && data.discount_amount <= 0 && data.debt_amount <= 0) {
			return true;
		}

		if (!data.client_id) {
			return true;
		}

		// if (data.status === 3 && isSave) {
		// 	return true;
		// }

		return false;
	}

	return (
		<>
			<div className="d-flex gap-2">
				<div className="payment-left">
					<div className="p-2">
						{data.parent_id && !id &&
							<div className="alert alert-warning py-1 px-2 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
								<i className="uil-link"></i>
								<span><b>#{data.parent_id}</b> ga qo'shimcha zakaz</span>
							</div>
						}
						{data.parent_id && id &&
							<div className="alert alert-warning py-1 px-2 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
								<i className="uil-link"></i>
								<span><b>#{data.parent_id}</b> ga qo'shimcha zakaz — Bu <b>#{data.parent_id}-{data.cheque_suffix}</b></span>
							</div>
						}
						{!data.parent_id && data.cheque_suffix === 'A' &&
							<div className="alert alert-success py-1 px-2 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
								<i className="uil-link"></i>
								<span>Bu <b>#{data.id}-A</b> asosiy chek — qo'shimcha zakazlari mavjud</span>
							</div>
						}
						<div className="d-between">
							<div className="tabs mb-3">
								<div className={`tab ${activeTab === 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}>
									{t('profiled_sheeting')}
								</div>
								<div className={`tab ${activeTab === 2 ? 'active' : ''}`} onClick={() => setActiveTab(2)}>
									{t('accessory')}
								</div>
								<div className={`tab ${activeTab === 4 ? 'active' : ''}`} onClick={() => setActiveTab(4)}>
									{t('tunikofon')}
								</div>
								<div className={`tab ${activeTab === 3 ? 'active' : ''}`} onClick={() => setActiveTab(3)}>
									{t('products')}
								</div>
							</div>

							{(!id && data?.products?.length > 0) &&
								<button className="btn btn-outline-danger" onClick={() => setModalConfirm({ show: true })}>
									<div className="d-between gap-2">
										<i className="uil-times"></i>
										{t('clear')}
									</div>
								</button>
							}
						</div>

						<div className="cashbox-products">
							{activeTab === 1 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('corrugated')}</th>
											<th style={{ width: '25%' }}>{t('roll')}</th>
											<th style={{ width: '5%' }} className="text-center">{t('party')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('size')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '7%' }} className="text-end">{t('metr')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('price')}</th>
											<th style={{ width: '20%' }} className="text-end">{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td className="p-0">
													<div className="position-relative">
														<Select
															classNamePrefix="border-none bs-none"
															options={products.shapes.filter(item => !item.is_prepared)}
															value={products.shapes.find(option => (option.product_id === item.product_id && option.is_prepared === item.is_prepared)) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `${option.name} ${option?.balance_id ? `(${option.balance})` : ''}`}
															getOptionValue={(option) => `${option.product_id} ${option.is_prepared}`}
															openMenuOnFocus={true}

														/>
													</div>
												</td>
												<td className="p-0">
													<div className="position-relative" onKeyDownCapture={(e) => handleRollCategoryKeyDown(e, index)}>
														<Select
															classNamePrefix="border-none bs-none"
															isDisabled={item.is_prepared}
															options={products.categories}
															value={item.is_prepared ? { name: item.element_name, balance_id: item.element_balance_id } : products?.rolls?.find(option => (option.balance_id === item.element_balance_id)) ?? ''}
															// value={products?.categories?.find(option => option.id === item.element_id)}
															onChange={(option) => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: option.products })}
															openMenuOnFocus={true}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) =>
																`${option.name}
																 ${(option?.products?.length > 0 || option.balance > 0) ?
																	`(${option?.products?.length ? option.products.length : formatMoney(option.balance)})`
																	:
																	''
																}`
															}
															getOptionValue={(option) => option.balance_id}
															ref={(el) => (rollSelectRefs.current[index] = el)}

														/>
														<i className="uil-ellipsis-h custom-select-btn" role="button" tabIndex={0}
															title="Partiya tanlash (Enter)"
															onClick={() => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls })}
															onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls }); } }} />
													</div>
												</td>
												<td className="text-center">{formatDate(item.created_at)}</td>
												<td className={`text-end ${isOverStock(item) ? 'bg-danger text-white' : ''}`}>
													<b>
														{item.actual_balance != null ? formatMoney(item.actual_balance) : formatMoney(item.balance)}
													</b>
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="element_quantity" value={formatMoneyInput(item.element_quantity)}
														onChange={(e) => handleChangeProduct(index, e)} disabled={item.is_prepared}
														ref={(el) => { refs.current[index] = el; sizeRefs.current[index] = el; }} />
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="quantity" value={formatMoneyInput(item.quantity)}
														onChange={(e) => handleChangeProduct(index, e)} ref={(el) => inputRefs.current[index] = el} />
												</td>
												<td className="text-end">
													{formatMoney(item.metr, 3)}
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off"
														name="sale_price"
														value={formatMoneyInput(item.sale_price)}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)}
													/>
												</td>
												<td className="text-end">
													{formatMoney(item.sale_price * item.metr)}
												</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex gap-1">
													<button type="button" className="btn-sm btn-primary" style={{ flex: 1 }}
														onClick={() => addToList()}>
														✂️ {t('add')}
													</button>
													<button type="button" className="btn-sm btn-success" style={{ flex: 1 }}
														onClick={() => addReadyRow()}>
														📦 Tayyor
													</button>
												</div>
											</td>
											<td className="fw-bold">
												{t('total')}
											</td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[4]?.metr, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[4]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
							{activeTab === 2 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('accessory')}</th>
											<th style={{ width: '25%' }}>{t('roll')}</th>
											<th style={{ width: '5%' }} className="text-center">{t('party')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('width')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('size')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('metr')}</th>
											<th style={{ width: '4%', minWidth: '70px' }} className="text-end" title="Метр / Длина * Ширина">
												{t('roll_m')}
											</th>
											<th style={{ width: '6%' }} className="text-end">
												<CustomTooltip text="(Цена прихода + Наценка) * Рулон М / Метр">
													{t('price')}
												</CustomTooltip>
											</th>
											<th style={{ width: '10%' }} className="text-end" title={`${t('price')} * ${t('roll_m')}`}>{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td>
													<div className="position-relative">
														<Select
															classNamePrefix="border-none bs-none"
															options={products.accessories.filter(item => !item.is_prepared)}
															value={products.accessories.find(option => (option.product_id === item.product_id && option.is_prepared === item.is_prepared)) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `${option.name} ${option?.balance_id ? `(${option.balance})` : ''}`}
															getOptionValue={(option) => `${option.product_id} ${option.is_prepared}`}
															openMenuOnFocus={true}
														/>
													</div>
												</td>
												<td>
													<div className="position-relative" onKeyDownCapture={(e) => handleRollCategoryKeyDown(e, index)}>
														<Select
															classNamePrefix="border-none bs-none"
															isDisabled={item.is_prepared}
															options={products.categories}
															value={item.is_prepared ? { name: item.element_name } : products?.rolls?.find(option => (option.balance_id === item.element_balance_id)) ?? ''}
															// value={products?.categories?.find(option => option.id === item.element_id)}
															onChange={(option) => handleChangeCategoriesSelect(index, option)}
															openMenuOnFocus={true}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) =>
																`${option.name}
																 ${(option?.products?.length > 0 || option.balance > 0) ?
																	`(${option?.products?.length ? option.products.length : formatMoney(option.balance)})`
																	:
																	''
																}`
															}
															getOptionValue={(option) => option.balance_id}
															ref={(el) => (rollSelectRefs.current[index] = el)}
														/>
														<i className="uil-ellipsis-h custom-select-btn" role="button" tabIndex={0}
															title="Partiya tanlash (Enter)"
															onClick={() => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls })}
															onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls }); } }} />
													</div>
												</td>
												<td className="text-center">{formatDate(item.created_at)}</td>
												<td className="text-end">{item.width}</td>
												<td className={`text-end ${isOverStock(item) ? 'bg-danger text-white' : ''}`}>
													<b>
														{item.actual_balance != null ? formatMoney(item.actual_balance) : formatMoney(item.balance)}
													</b>
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="element_quantity" value={formatMoneyInput(item.element_quantity)}
														disabled={item.is_prepared} onChange={(e) => handleChangeProduct(index, e)}
														ref={(el) => { refs.current[index] = el; sizeRefs.current[index] = el; }} />
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="quantity" value={formatMoneyInput(item.quantity)}
														onChange={(e) => handleChangeProduct(index, e)} ref={(el) => inputRefs.current[index] = el} />
												</td>
												<td className="text-end">{formatMoney(item.metr, 3)}</td>
												<td className="text-end">{formatMoney(item.roll_metr, 3)}</td>
												{/* <td className="text-end">{formatMoney(item.accessory_sale_price / item.metr)}</td> */}
												<td className="td-input">
													<input type="text" autoComplete="off"
														name="accessory_sale_price_metr"
														value={formatMoneyInput(item.accessory_sale_price_metr)}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)} />
												</td>
												<td className="text-end">{formatMoney(item.accessory_total_price)}</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex gap-1">
													<button type="button" className="btn-sm btn-primary" style={{ flex: 1 }}
														onClick={() => addToList(1)}>
														✂️ {t('add')}
													</button>
													<button type="button" className="btn-sm btn-success" style={{ flex: 1 }}
														onClick={() => addReadyRow()}>
														📦 Tayyor
													</button>
												</div>
											</td>
											<td className="fw-bold">
												{t('total')}
											</td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[3]?.metr, 3)}</td>
											<td className="text-end fw-bold">{formatMoney(data?.total[3]?.roll_metr, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[3]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
							{activeTab === 3 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('product')}</th>
											<th style={{ width: '10%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '10%' }}>{t('unit')}</th>
											<th style={{ width: '30%' }}></th>
											<th style={{ width: '6%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('price')}</th>
											<th style={{ width: '15%' }} className="text-end">{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td>
													<div className="position-relative">
														{/* {JSON.stringify(item.is_prepared)} */}
														<Select
															classNamePrefix="border-none bs-none"
															options={products.products}
															value={item.is_prepared ? { name: `${item.name} [ ${item.element_name} ]` } : products.products.find(option => option.product_id === item.product_id) ?? ''}
															// value={products.products.find(option => option.product_id === item.product_id) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.product_id}
															openMenuOnFocus={true}
															ref={(el) => (refs.current[index] = el)}
														/>
														<i className="uil-ellipsis-h custom-select-btn"
															onClick={() => setModalSelectProduct({ show: true, is_prepared: true, index: index, key: 'product_id' })} />
													</div>
												</td>
												<td className="text-end">
													<b>{item.balance}</b>
												</td>
												<td>{item.unit_name}</td>
												<td></td>
												<td className={`td-input ${!item.quantity && 'danger'}`}>
													<input type="text" autoComplete="off" name="quantity" value={item.quantity}
														onChange={(e) => handleChangeProduct(index, e)} />
												</td>
												<td className={`td-input ${!item.sale_price && 'danger'}`}>
													<input type="text" autoComplete="off" name="sale_price" value={item.sale_price}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)} />
												</td>
												<td className="text-end">
													{formatMoney(item.sale_price * item.quantity)}
												</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<button type="button" className="btn-sm btn-primary w-100" onClick={() => addToList(1)}>
													{t('add')}
												</button>
											</td>
											<td className="fw-bold">{t('total')}</td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[1]?.quantity, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[1]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
							{activeTab === 4 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('accessory')}</th>
											<th style={{ width: '25%' }}>{t('roll')}</th>
											<th style={{ width: '5%' }} className="text-center">{t('party')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('width')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('size')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '4%', minWidth: '70px' }} className="text-end" title="Метр / Длина * Ширина">{t('roll_m')}</th>
											<th style={{ width: '4%', minWidth: '70px' }} className="text-end" title="Метр / Длина * Ширина">{t('sq_m')}</th>
											<th style={{ width: '6%' }} className="text-end" >
												<CustomTooltip text="(Цена прихода + Наценка) * Длина">
													{t('price')}
												</CustomTooltip>
											</th>
											<th style={{ width: '10%' }} className="text-end" title={`${t('price')} * ${t('sq_m')}`}>{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td>
													<div className="position-relative">
														<Select
															classNamePrefix="border-none bs-none"
															options={products?.tunicophones?.filter(item => !item.is_prepared)}
															value={products.tunicophones.find(option => (option.product_id === item.product_id && option.is_prepared === item.is_prepared)) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `${option.name} ${option?.balance_id ? `(${option.balance})` : ''}`}
															getOptionValue={(option) => `${option.product_id} ${option.is_prepared}`}
															openMenuOnFocus={true}
															ref={(el) => (refs.current[index] = el)}
														/>
													</div>
												</td>
												<td>
													<div className="position-relative" onKeyDownCapture={(e) => handleRollCategoryKeyDown(e, index)}>
														<Select
															classNamePrefix="border-none bs-none"
															isDisabled={item.is_prepared}
															options={products.categories}
															value={products?.rolls?.find(option => option.balance_id === item.element_balance_id) ?? ''}
															// value={products?.categories?.find(option => option.id === item.element_id)}
															onChange={(option) => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: option.products }) ?? ''}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) =>
																`${option.name}
																 ${(option?.products?.length > 0 || option.balance > 0) ?
																	`(${option?.products?.length ? option.products.length : formatMoney(option.balance)})`
																	:
																	''
																}`
															}
															getOptionValue={(option) => option.balance_id}
															ref={(el) => (rollSelectRefs.current[index] = el)}
														/>
														<i className="uil-ellipsis-h custom-select-btn" role="button" tabIndex={0}
															title="Partiya tanlash (Enter)"
															onClick={() => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls })}
															onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls }); } }} />
													</div>
												</td>
												<td className="text-center">{formatDate(item.created_at)}</td>
												<td className="text-end">{item.width}</td>
												<td className={`text-end ${isOverStock(item) ? 'bg-danger text-white' : ''}`}>
													<b>
														{item.actual_balance != null ? formatMoney(item.actual_balance) : formatMoney(item.balance)}
													</b>
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="element_quantity" value={formatMoneyInput(item.element_quantity)}
														disabled={item.is_prepared} onChange={(e) => handleChangeProduct(index, e)}
														ref={(el) => (sizeRefs.current[index] = el)} />
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="quantity" value={formatMoneyInput(item.quantity)}
														onChange={(e) => handleChangeProduct(index, e)} ref={(el) => inputRefs.current[index] = el} />
												</td>
												<td className="text-end">{formatMoney(item.roll_metr, 3)}</td>
												<td className="text-end">{formatMoney(item.kv_metr, 3)}</td>
												<td className="td-input">
													<input type="text"
														autoComplete="off"
														name="accessory_sale_price"
														value={formatMoneyInput(item.accessory_sale_price)}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)} />
												</td>
												<td className="text-end">{formatMoney(item.accessory_total_price)}</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex gap-1">
													<button type="button" className="btn-sm btn-primary" style={{ flex: 1 }}
														onClick={() => addToList(1)}>
														✂️ {t('add')}
													</button>
													<button type="button" className="btn-sm btn-success" style={{ flex: 1 }}
														onClick={() => addReadyRow()}>
														📦 Tayyor
													</button>
												</div>
											</td>
											<td className="fw-bold">
												{t('total')}
											</td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[5]?.roll_metr, 3)}</td>
											<td className="text-end fw-bold">{formatMoney(data?.total[5]?.kv_metr, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[5]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
						</div>
					</div>
					<div className="bottom-btn">

						<div className="d-between align-items-end gap-3">
							<div className="w-75">
								<div className="d-flex gap-3 mb-2">
									<div className="w-100">
										<label>{t('client')}<span className="required-mark">*</span></label>
										<div className="position-relative">
											<Select
												className="bottom-select"
												menuPlacement='top'
												classNamePrefix="bottom-select"
												options={clients}
												value={clients?.find(option => option.id === data.client_id)}
												onChange={(option) => selectClient(option)}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												formatOptionLabel={(option, { context }) => {
													const bal = Number(option.balance)
													const badge = bal < 0
														? <span className="text-danger fw-600" style={{ whiteSpace: 'nowrap' }}>{t('debt')}: {formatMoney(Math.abs(bal))}</span>
														: bal > 0
															? <span className="text-success" style={{ whiteSpace: 'nowrap' }}>{t('advance')}: {formatMoney(bal)}</span>
															: null
													// Tanlangan qiymat: nom yonida inline (dropdown ikonasi bilan urishmasin). Royxatda: nom chap, qarz ong.
													return context === 'value'
														? <span className="d-inline-flex align-items-center gap-2">{option.name}{badge}</span>
														: <div className="d-flex justify-content-between align-items-center gap-2"><span>{option.name}</span>{badge}</div>
												}}
												getOptionValue={(option) => option.id}
											/>
											<i className="uil-plus custom-select-btn" onClick={() => toggleUserModal(true)} />
											<i className="uil-search custom-select-btn" style={{ right: '75px' }} onClick={() => toggleSearchUserModal(true)} />
										</div>

									</div>
									<div className="w-100">
										<label>{t('status')}</label>
										<Select
											className="bottom-select"
											menuPlacement='top'
											classNamePrefix="bottom-select"
											options={chequeStatuses?.filter(option => option.id !== 3 || data.status === 3)}
											value={chequeStatuses?.find(option => option.id === data.status)}
											onChange={(option) => setData({ ...data, status: option.id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>

									<div className="w-100">
										<label>{t('note')}</label>
										<input type="text" className="form-control small" value={data.note} onChange={(e) => setData({ ...data, note: e.target.value })} />
									</div>
								</div>

								<div className="d-flex gap-3 mb-2">
									<div className="w-100">
										<label className={!data.region_id ? 'text-danger fw-600' : ''}>
											{t('region')} <span className="text-danger">*</span>
										</label>
										<Select
											className="bottom-select"
											menuPlacement='top'
											classNamePrefix="bottom-select"
											options={regionOptions()}
											value={regionOptions().find(o => o.value === data.region_id) || null}
											onChange={(o) => setData({ ...data, region_id: o?.value ?? null })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.path ? `${o.name} — ${o.path}` : o.name}
											getOptionValue={(o) => o.value}
										/>
									</div>
									<div className="w-100">
										<label style={(data.status === 2 || data.status === 3) && !data.delivery_date ? { color: '#dc3545', fontWeight: 600 } : {}}>
											{t('delivery_date')}
											{(data.status === 2 || data.status === 3) && <span className="text-danger ms-1">*</span>}
										</label>
										<div className="calendar-input">
											<DatePicker
												className={`form-control${(data.status === 2 || data.status === 3) && !data.delivery_date ? ' is-invalid' : ''}`}
												selected={data.delivery_date ? new Date(data.delivery_date) : null}
												onChange={(date) => setData({
													...data,
													'delivery_date': formatDate(date, 'yyyy-MM-dd HH:mm')
												})}
												dateFormat="dd.MM.yyyy HH:mm"
												showTimeSelect
												timeIntervals={30}
												timeFormat="HH:mm"
												timeCaption={t('time')}
											/>
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>

									<div className="w-100">
										<label>{t('delivery_type')}</label>
										<Select
											isClearable
											options={deliveryTypes}
											value={deliveryTypes.find(option => option.id === data.delivery_type_id) || ''}
											onChange={(option) => setData({ ...data, 'delivery_type_id': option?.id, 'delivery_type_name': option?.name })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>

									<div className="w-100">
										<label>{t('delivery_price')}</label>
										<input type="text" className="form-control small" value={formatMoneyInput(data.delivery_price)}
											onChange={(e) => setData({ ...data, delivery_price: e.target.value.replace(/[^\d.]/g, '') })} />
									</div>

								</div>

								{/* Tўлов режаси — pul qanday keladi. Majburiy; qarz qoladigan rejalarda muddat ham so'raladi. */}
								<div className="d-flex gap-3 w-100 mb-2" style={{ alignItems: 'flex-end' }}>
									<div style={{ flex: 1, minWidth: 0 }}>
										<label className={!data.payment_plan ? 'text-danger fw-600' : ''}>
											{t('payment_plan')} <span className="text-danger">*</span>
										</label>
										<div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap' }}>
											{PAYMENT_PLANS.map(plan => (
												<button key={plan.key} type="button"
													style={{ flex: '1 1 0', whiteSpace: 'nowrap', minWidth: 0 }}
													className={`btn btn-sm ${data.payment_plan === plan.key ? 'btn-primary' : 'btn-outline-secondary'}`}
													onClick={() => setData({
														...data,
														payment_plan: plan.key,
														// Faqat Насия'da sana kerak; cash/half/driver — sanasiz (tozalanadi)
														debt_date: plan.key === 'nasiya' ? data.debt_date : null,
													})}>
													{plan.icon} {t(plan.i18n)}
												</button>
											))}
										</div>
									</div>

									{planNeedsDebtDate(data.payment_plan) &&
										<div style={{ flex: '0 0 175px', width: '175px' }}>
											<label className={!data.debt_date ? 'text-danger fw-600' : ''}>
												{t('nasiya_date')} <span className="text-danger">*</span>
											</label>
											<div className="calendar-input">
												<DatePicker
													className={`form-control small${!data.debt_date ? ' is-invalid' : ''}`}
													selected={data.debt_date ? new Date(data.debt_date) : null}
													onChange={(date) => setData({ ...data, debt_date: formatDate(date, 'yyyy-MM-dd') })}
													dateFormat="dd.MM.yyyy"
													placeholderText={t('nasiya_date')}
												/>
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
									}

									{/* СКИДКА — pastdan shu yerga ko'chirildi.
									    "Qolganini to'ldirish" (💵) tugmasi ATAYIN yo'q: u yerda bir bosishda
									    butun chek bepul bo'lib ketardi. */}
									{discountIndex !== -1 &&
										<div style={{ flex: '0 0 150px', width: '150px' }}>
											<label>{data.payments[discountIndex]?.name}</label>
											<input type="text" className="form-control small text-end"
												value={formatMoneyInput(data.payments[discountIndex]?.amount)}
												onChange={(e) => handleChangePayment(discountIndex, e)} />
										</div>
									}
								</div>

								{/* Pastdagi to'lov qatori butunlay olib tashlandi:
								      Накд / Банк / P2P / Доллар — pul chek YOZILGANDA emas, OLINGANDA kiritiladi
								                                   (cheklar ro'yxatidagi ₴ "To'lov olish" tugmasi).
								      Насия                       — endi AVTOMATIK hisoblanadi (jami − to'langan),
								                                   kassir qo'lda yozmaydi.
								      Скидка                      — yuqoriga, "Тўлов режаси" qatoriga ko'chirildi. */}
							</div>

							<div className="h-100 w-25">
								<div className="mb-2">
									<div className="d-between fw-600 fz-20">
										<div>{t('to_pay')}</div>
										<div>{data.total_amount ? formatMoney(data.total_amount) : 0}</div>
									</div>
									<div className="d-between fw-600">
										<div>{t('discount')}</div>
										<div>{formatMoney(data.discount_amount)}</div>
									</div>
									{/* Eski chekni tahrirlaganda to'langan pul ko'rinsin (yangi chekda 0) */}
									{data.paid > 0 &&
										<div className="d-between fw-600">
											<div>{t('paid')}</div>
											<div className="text-success">{formatMoney(data.paid)}</div>
										</div>
									}
									{/* Насия — avtomatik. Pul ₴ tugmasi orqali olinadi. */}
									<div className="d-between fw-600 fz-18 pt-1 border-top mt-1">
										<div>{t('debt')}</div>
										<div className="text-danger">{formatMoney(data.debt_amount)}</div>
									</div>
								</div>

								<div className="d-flex h-100 gap-2 mb-2">
									<button className="btn btn-info" onClick={() => printCheque()} disabled={isButtonDisabled()}>
										<i className="uil-print fz-18"></i>
									</button>
									<button className="btn btn-info" onClick={() => printCheque(true)} disabled={isButtonDisabled()}>
										<i className="uil-print fz-18"></i> A4
									</button>
								</div>

								{data.status > 0 &&
									<div className="d-flex h-100 gap-2">
										<button className="btn btn-success" disabled={chequeSubmitting} onClick={() => createCheque()}>
											{t('save')}
										</button>
										{id && !data.parent_id &&
											<button className="btn btn-warning text-white" onClick={() => navigate('/cashbox/create', {
												state: {
													parent_id: Number(id),
													client_id: data.client_id,
													delivery_type_id: data.delivery_type_id,
													address: data.address,
												}
											})}>
												+ Qo'shimcha zakaz
											</button>
										}
									</div>
								}
							</div>
						</div>


					</div>

				</div>
			</div>

			<Cheque data={data} printChequeRef={printChequeRef} />

			<DeleteModal
				showNote={true}
				modalDelete={modalDelete}
				setModalDelete={toggleModalDelete}
				setNote={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<DeleteModal
				modalDelete={modalConfirm}
				setModalDelete={() => setModalConfirm({ show: false })}
				deleteItem={clearData}>
			</DeleteModal>

			<Modal show={modalSelectProduct.show} animation={false} restoreFocus={false} centered size="xl" dialogClassName="cashbox-product-modal"
				onHide={() => setModalSelectProduct({ ...modalSelectProduct, show: false })}>
				<Modal.Body>
					<div>
						<h5 className="mb-3 fw-bold">
							{modalSelectProduct.key === 'product_id' ? "📦 Tayyor ombordan tanlash" : "📋 Rulon (partiya) tanlash"}
						</h5>
						<div className="mb-2">
							<label>{t('search')}</label>
							<input autoFocus type="text" className="form-control"
								onChange={(e) => setModalSelectProduct({ ...modalSelectProduct, search: e.target.value })} />
						</div>

						<div style={{ minHeight: '500px', overflow: 'auto' }}>
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										<th style={{ width: '25%' }}>{t('name2')}</th>
										{modalSelectProduct.key === 'product_id' &&
											<>
												<th style={{ width: '10%' }}>{t('warehouse')}</th>
												<th style={{ width: '25%' }}>{t('roll')}</th>
												<th style={{ width: '10%' }} className="text-end">{t('balance2')}</th>
												<th style={{ minWidth: '75px' }}>{t('unit')}</th>
												<th style={{ width: '10%' }} className="text-end">{t('sale_price')}</th>
												<th style={{ minWidth: '125px' }} className="text-center">{t('created')}</th>
											</>
										}
										{modalSelectProduct.key === 'element_id' &&
											<>
												<th style={{ width: '5%' }}>{t('id')}</th>
												<th style={{ minWidth: '70px' }}>{t('unit')}</th>
												<th style={{ minWidth: '60px' }} className="text-end">{t('quantity')}</th>
												<th style={{ minWidth: '80px' }} className="text-end">{t('balance2')}</th>
												<th style={{ 'minWidth': '60px' }} className="text-end">
													<CustomTooltip text={`${t('quantity')} / 1200 * 1000`}>
														{t('1м-кг')}
													</CustomTooltip>
												</th>
												<th style={{ 'minWidth': '60px' }} className="text-end">
													<CustomTooltip text={`1200 / ${t('quantity')}`}>
														{t('1т-м')}
													</CustomTooltip>
												</th>
												<th style={{ minWidth: '115px' }} className="text-center">{t('date')}</th>
												<th style={{ width: '10%' }} className="td-ellipsis">{t('supplier')}</th>
												<th style={{ width: '10%' }}>{t('opened_by')}</th>
												<th style={{ minWidth: '125px' }} className="text-center">{t('opened_at')}</th>
												<th style={{ width: '10%' }} className="text-center">{t('status')}</th>
											</>
										}
									</tr>
								</thead>
								<tbody>
									{getProductsList().map((item, index) => (
										<tr key={index}
											className={`cursor ${index === activeRowIndex ? 'table-active' : ''}`}
											onClick={() => handleChangeProductSelect(modalSelectProduct.index, modalSelectProduct.key, item)}>
											<td>{item.name}</td>
											{modalSelectProduct.key === 'product_id' &&
												<>
													<td>{item.wms_name}</td>
													<td>{item.element_name}</td>
													<td className="text-end">{formatMoney(item.balance, 3)}</td>
													<td>{item.unit_name}</td>
													<td className="text-end">{formatMoney(item.sale_price)}</td>
													<td className="text-center">{formatDate(item.prepared_at)}</td>
												</>
											}
											{modalSelectProduct.key === 'element_id' &&
												<>
													<td>{item.element_id}</td>
													<td>{item.unit_name}</td>
													<td className="text-end">{item.quantity}</td>
													<td className="text-end">{formatMoney(item.actual_balance, 3)}</td>
													<td className="text-end text-nowrap vertical-middle">
														{item.quantity ? formatMoney(Number(item.original_quantity ?? 0) / item.quantity * 1000, 2) : 0}
													</td>
													<td className="text-end text-nowrap vertical-middle">
														{item.quantity ? formatMoney(item.quantity / Number(item.original_quantity)) : 0}
													</td>
													<td className="text-center">{formatDate(item.created_at)}</td>
													<td className="td-ellipsis">{item.supplier_name}</td>
													<td>{item.opened_by}</td>
													<td className="text-center">{formatDate(item.opened_at, "dd.MM.yyyy HH:mm")}</td>
													<td className={`text-center text-white ${item.is_opened ? 'bg-info' : 'bg-primary'}`}>
														{item.is_opened ? t('open') : t('new')}
													</td>
												</>
											}
										</tr>
									))}

								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={modalSearchUser.show} animation={false} centered size="lg"
				onHide={() => setModalSearchUser({ ...modalSearchUser, show: false })}>
				<Modal.Body>
					<div className="addition-wrapper no-scroll">
						<div className="mb-2">
							<label>{t('search')}</label>
							<input autoFocus type="text" className="form-control"
								onChange={(e) => setModalSearchUser({ ...modalSearchUser, search: e.target.value })} />
						</div>

						<div>
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										<th style={{ width: '20%' }}>{t('name')}</th>
										<th style={{ width: '5%' }}>{t('phone')}</th>
										<th style={{ width: '20%' }}>{t('note')}</th>
										<th style={{ width: '20%' }}>{t('address')}</th>
										<th style={{ width: '15%' }} className="text-end">{t('debt')}</th>
										<th style={{ width: '15%' }} className="text-end">{t('number_of_checks')}</th>
									</tr>
								</thead>
								<tbody>
									{getClientsList().map((item, index) => (
										<tr className="cursor" key={index} onClick={() => toggleSearchUserModal(false, item)}>
											<td>{item.name}</td>
											<td>{item.phone}</td>
											<td>{item.note}</td>
											<td>{item.address}</td>
											<td className="text-end">{formatMoney(item.balance)}</td>
											<td className="text-end">{formatMoney(item.count_cheques)}</td>
										</tr>
									))
									}
								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={modalQuantity.show} animation={false}
				centered size="sm"
				onHide={() => setModalQuantity({ ...modalQuantity, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>{modalQuantity.name}</Modal.Title>
				</Modal.Header>


				<Modal.Body>
					<form onSubmit={(e) => addProductType2(e)}>
						<div>
							<label htmlFor="quantity">{t('quantity')}</label>
							<input
								id="quantity"
								type="text"
								className="form-control"
								autoFocus
								onChange={(e) => setModalQuantity({ ...modalQuantity, quantity: e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>

						<hr />

						<div className="d-flex gap-2 w-100">
							<button className="btn btn-warning w-100" type="button"

								onClick={() => setModalQuantity({ ...modalQuantity, show: false })}>
								{t('cancel')}
							</button>

							<button className="btn btn-primary w-100" type="submit">
								{t('confirm')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			<Modal show={modalUser.show} animation={false}
				centered size="md"
				onHide={() => setModalUser({ ...modalUser, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>
						{modalUser.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUser(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={modalUser.name ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="number" className="form-control" name="phone"
								value={modalUser.phone ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('client_types')}</label>
							<Select
								isClearable
								options={clientTypes}
								value={clientTypes.find(option => option.id === modalUser.client_type_id) || ''}
								onChange={(option) => setModalUser({ ...modalUser, 'client_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('birthday')}</label>
							<input type="date" className="form-control" name="birthday"
								value={modalUser.birthday ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>
						<div className="d-flex justify-content-between mb-2">
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setModalUser({ ...modalUser, 'gender': 1 })}
										style={{ 'backgroundColor': modalUser.gender === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setModalUser({ ...modalUser, 'gender': 1 })}>
										{t('man')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setModalUser({ ...modalUser, 'gender': 2 })}
										style={{ 'backgroundColor': modalUser.gender === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setModalUser({ ...modalUser, 'gender': 2 })}>
										{t('woman')}
									</span>
								</div>
							</div>
						</div>

						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={modalUser.note ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleUserModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>


			<Modal show={modalDebtDate.show} animation={false} centered size="md"
				onHide={() => setModalDebtDate({ show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('debt_payment_date')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex gap-2">
						<div className="form-group w-25">
							<label>{t('days')}</label>
							<input
								type="text"
								name="debt_days"
								className="form-control"
								onChange={handleChange}
								value={data?.debt_days ?? ""}
								disabled={data.debt_date ? false : true}
							/>
						</div>

						<div className="w-100">
							<label>{t('date')}</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									selected={data.debt_date ? new Date(data.debt_date) : null}
									onChange={(date) => setData({
										...data,
										'debt_date': formatDate(date, 'yyyy-MM-dd'),
										'debt_date_original': formatDate(date, 'yyyy-MM-dd')
									})}
									dateFormat="dd.MM.yyyy"
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>
						{/* <div className="form-group w-100">
							<label>{t('date')}</label>
							<MaskedInput
								name="debt_date"
								mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
								className="form-control"
								guide={true}
								onChange={handleChange}
								value={data?.debt_date ?? ""}
							/>
						</div> */}
					</div>
					{/* <div className="d-flex gap-2">
						<div className="form-group w-100">
							<label>{t('days')}</label>
							<input
								className="form-control"
								guide={true}
								onChange={handleChange}
							// value={data?.debt_date ?? ""}
							/>
						</div>
						<div className="form-group w-100">
							<label>{t('hours')}</label>
							<input
								className="form-control"
								guide={true}
								onChange={handleChange}
							// value={data?.debt_date ?? ""}
							/>
						</div>
					</div> */}

					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setModalDebtDate({ show: false })}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100" onClick={() => createCheque(false)}>{t('save')}</button>
					</div>

				</Modal.Body>
			</Modal>

			{/* <Modal show={modalDelivery.show} animation={false}
				centered size="md"
				onHide={() => setModalDelivery({ ...modalDelivery, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('delivery')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createDeliveryType(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('address')}</label>
							<input type="text" className="form-control" name="address"
								value={modalDelivery.address ?? ''}
								onChange={(e) => handleInputDeliveryChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('delivery_date')}</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									selected={modalDelivery.delivery_date ? new Date(modalDelivery.delivery_date) : null}
									onChange={(date) => setModalDelivery({
										...modalDelivery,
										'delivery_date': formatDate(date, 'yyyy-MM-dd HH:mm')
									})}
									dateFormat="dd.MM.yyyy HH:mm"
									showTimeSelect
									timeIntervals={30}
									timeFormat="HH:mm"
									timeCaption={t('time')}
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>

						<div className="form-group">
							<label>{t('delivery_type')}</label>
							<Select
								isClearable
								options={deliveryTypes}
								value={deliveryTypes.find(option => option.id === modalDelivery.delivery_type_id) || ''}
								onChange={(option) => setModalDelivery({ ...modalDelivery, 'delivery_type_id': option?.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalDelivery({ ...modalDelivery, show: false })}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('confirm')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal> */}
		</>
	)
}

export default Cashbox